// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__YQnFx","item":"Pagination_item__GJaNP","active":"Pagination_active__fQjqX","disabled":"Pagination_disabled__JWsGh"};